module.exports = __webpack_public_path__ + "img/transact.d8c4d4d1.jpg";